import React from 'react';
import * as Styled from './CouponDialogSmsSuccess.styled';
/**
 * Coupon Dialog Success displays the success messaging and new-user coupon code
 * once a user has signed up for our mailing list.
 */
const CouponDialogSmsSuccess = () => (
  <Styled.CouponDialogSmsSuccess>
    <Styled.SmsIcon />
    <Styled.SmsBodyHeading>
      Almost There!
      <br />
      Check your text messages.
    </Styled.SmsBodyHeading>
    <Styled.SmsBodyText>
      A text message has been sent to you.
      <br />
      Please confirm your number to start receiving early access, exclusive
      deals, and much more!
    </Styled.SmsBodyText>
  </Styled.CouponDialogSmsSuccess>
);

export default CouponDialogSmsSuccess;
